module.exports = __webpack_public_path__ + "img/qrcode.be70e2f8.png";